// "3m ago" / "2h ago" / "yesterday" style formatting for run + agent timestamps.
export function relativeTime(input: string | Date | null | undefined): string {
  if (!input) return 'never';
  const then = typeof input === 'string' ? new Date(input) : input;
  const ms = then.getTime();
  if (Number.isNaN(ms)) return 'never';

  const diff = Date.now() - ms;
  const sec = Math.round(diff / 1000);
  if (sec < 45) return 'just now';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day === 1) return 'yesterday';
  if (day < 7) return `${day}d ago`;
  const wk = Math.round(day / 7);
  if (wk < 5) return `${wk}w ago`;
  return then.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
